// 插件路由
const routes = [
	{ 
        path: '/financing', 
        component: () => import(/* webpackChunkName: "financing" */ '~/addon/financing/pages/financing.vue') 
    },
]

export default routes;


// WEBPACK FOOTER //
// ./src/addon/financing/router/index.js